import { render, staticRenderFns } from "./QuestionReview.vue?vue&type=template&id=a0000b72&scoped=true&"
import script from "./QuestionReview.vue?vue&type=script&lang=js&"
export * from "./QuestionReview.vue?vue&type=script&lang=js&"
import style0 from "./QuestionReview.vue?vue&type=style&index=0&id=a0000b72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0000b72",
  null
  
)

export default component.exports